import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { BaseTheme } from '../base-theme';
import { StandardSectionIds } from './standard-theme.sections';

@Component({
  selector: 'app-standard-invoice-theme',
  templateUrl: './standard-invoice-theme.component.html',
  styleUrls: [
    './standard-invoice-theme.component.scss',
    '../../../../../assets/document-theme-styles/xemedo-theme-styles.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StandardInvoiceThemeComponent extends BaseTheme {
  public readonly StandardSectionIds = StandardSectionIds;
}
